// extracted by mini-css-extract-plugin
module.exports = {"Input":"Input_Input__2WBmr","Label":"Input_Label__39MCe","InputElement":"Input_InputElement__26fn_","Invalid":"Input_Invalid__2eL3J"};